var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('mx-column-data',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"config":_vm.config,"dataconfig":_vm.dataconfig},on:{"change":_vm.handleChange}}),_vm._v(_vm._s(_vm.Data)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }